import DevicesContextProvider from "./DeviceContext";
import LocationContextProvider from "./LocationContext";
import UIContextProvider from "./UIContext";
import UserContextProvider from "./UserContext";

const RootContext = ({ children }: {children: JSX.Element}) => {
  return (
    <UserContextProvider>
      <UIContextProvider>
        <DevicesContextProvider>
          <LocationContextProvider>
            { children }
          </LocationContextProvider>
        </DevicesContextProvider>
      </UIContextProvider>
    </UserContextProvider>
  );
};

export default RootContext;
